import { render, staticRenderFns } from "./OrdenCompraPendienteAceptada.vue?vue&type=template&id=006a6f13&"
import script from "./OrdenCompraPendienteAceptada.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraPendienteAceptada.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompraPendienteAceptada.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports